import { Button, Popover, SizableText, YStack, isWeb } from '@my/ui'
import { MoreVertical, X, Share } from '@tamagui/lucide-icons'
import config from 'app/config'
import { useShare } from 'app/features/sharing/hooks'
import { AuthUser } from 'app/provider/auth'
import { useState } from 'react'
import { LeaveGroupModal } from '../leave-group-modal'
import { limitToRange } from 'app/lib/limit-to-range'
export interface GroupCardOptionsProps {
  groupId: string
  href: string
  user: AuthUser | null
  canLeave: boolean
}

export const GroupCardOptions = (props: GroupCardOptionsProps) => {
  const groupHref = `/groups/${props.href}`
  const { onShare } = useShare({ href: config.siteUrl + groupHref })
  const [open, setOpen] = useState(false)
  const [leaveModalOpen, setLeaveModalOpen] = useState(false)

  const options = [
    {
      ...(!isWeb && {
        label: 'Share Group',
        icon: <Share size={24} />,
        onPress: () => {
          handleOpenChange(false)
          onShare()
        },
      }),
    },
    {
      ...(props.canLeave && {
        label: 'Leave Group',
        icon: <X size={24} color="red" />,
        color: 'red',
        onPress: () => {
          handleOpenChange(false)
          setLeaveModalOpen(true)
        },
      }),
    },
  ].filter((option) => option.label)

  if (options.length === 0) {
    return null
  }

  const itemHeight = 10 // In % of screen height
  const snapPoint = limitToRange(
    options.length * itemHeight + (isWeb ? 25 : 0),
    isWeb ? 40 : 25,
    80
  )

  const handleOpenChange = (nextOpen: boolean) => {
    setOpen(nextOpen)
  }

  return (
    <>
      <Popover
        key={`actionMenu-${props.groupId}`}
        placement="bottom-start"
        isBouncy
        anchor={
          <Button
            size="$3"
            px="$2"
            aria-label='Open group options'
            onPress={() => handleOpenChange(true)}
            plain
            icon={<MoreVertical size={24} />}
            disabled={options.length === 0}
          />
        }
        sheetProps={{
          snapPoints: [snapPoint],
        }}
        open={open}
        onOpenChange={handleOpenChange}
      >
        <YStack
          gap="$3.5"
          alignItems="center"
          jc="center"
          py="$3.5"
          $gtSm={{
            px: '$2',
            py: '$2.5',
            gap: '$2.5',
          }}
        >
          {options.map((option, index) => (
            <Button
              key={`actionMenu-${index}`}
              size="$5"
              plain
              onPress={option.onPress}
              icon={option.icon}
              alignItems="center"
              w="100%"
              $gtSm={{
                size: '$3',
                jc: 'flex-start',
              }}
            >
              <SizableText
                color={option.color || '$black'}
                size="$5"
                fow="500"
                $gtSm={{
                  size: '$3',
                  fow: '500'
                }}
              >
                {option.label}
              </SizableText>
            </Button>
          ))}
        </YStack>
      </Popover>
      <LeaveGroupModal
        groupId={props.groupId}
        open={leaveModalOpen}
        onOpenChange={setLeaveModalOpen}
      />
    </>
  )
}
